import { useContext } from 'react';

import type { FeatureFlagContextContext } from './types';

export function createFeatureFlagHook<Flags>(
  ldContext: FeatureFlagContextContext<Flags>
) {
  return () => {
    const context = useContext(ldContext);
    if (!context) {
      throw new Error(
        'a useFeatureFlagHook can only be used underneath its Provider.'
      );
    }
    return {
      ...context,
      isLoading: context.loadingState === 'loading',
      isError: context.loadingState === 'error',
    };
  };
}
